<template>
  <div class="programme">
    <common :title="'来源分布（单个方案）'"></common>
    <ul class="programme_list">
      <li v-for="(item, index) in list" :key="index">
        <div>
          <span>{{ item.key }}:</span> <span>{{ item.num }}条</span>
        </div>
        <div @click="detailsClick(item.key)">
          查看 >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import common from './common.vue';
import { warningSource } from '@/api/index'
import moment from 'moment';
import { geturl } from '@/utils/index';
export default {
  name: 'programme',
  components: {
    common
  },
  data() {
    return {
      list: [],

    }
  },
  mounted() {
    // window.location.search.split('=')[1];
    // const id = 'oEqTa6UrfBsR5xtBIgQv1MRaHikI'
    let params = geturl()
    if (params && params.openId) {
      const id = params.openId
      localStorage.setItem('id', id);
    }
    this.getList()
  },
  methods: {
    moment,
    routerClick() {
      this.$router.push('/details');
    },
    getList() {
      // 获取近7天的数据
      let endTime = moment().endOf('day').valueOf();
      let startTime = moment().subtract(7, 'days').startOf('day').valueOf();
      let data = {
        endTime: endTime,
        startTime: startTime,
        openId: localStorage.getItem('id')
      }
      warningSource(data).then(res => {
        this.list = res.sourceStatistics
      }).catch(err => {
        console.log(err)
      })
    },
    detailsClick(key) {
      // 跳转到详情页并传递当前时间 YYYY年M月D日
      this.$router.push({
        path: '/details',
        query: {
          source: key
        }
      })
    },
  }
}
</script>
 
<style lang = "less" scoped>
.programme {
  padding: .1rem;
  background: #fff;

  .programme_list {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      padding: .1rem 0;
      border-bottom: 1px solid #efe8cb;
    }
  }
}
</style>